import { getForecastDate } from "services/app.services";
import { useQuery } from "react-query";

export const useForecastDate = () => {
  return useQuery(["forecastDate"], () => getForecastDate(), {
    keepPreviousData: true,
    staleTime: 60 * 60 * 1000,
  });
};
